export const SET_BLOGS = "SET_BLOGS";
// export const ADD_BLOG = "ADD_BLOG";
// export const UPDATE_BLOG = "UPDATE_BLOG";
// export const DELETE_BLOG = "DELETE_BLOG";
